import {
    AdEvent,
    AdState,
    LiveBlogEvents,
    SharingEvent,
} from '@news-mono/web-common'
import React, { FC } from 'react'
import { Logger } from 'typescript-log'
import { AdUnitWrapper } from '../../..'
import {
    PublishedLiveEventItem,
    PublishedLiveEventPost,
    useIsComponentOnScreen,
} from '../helpers'
import { LiveEventPinnedPosts } from './LiveEventPinnedPosts'
import { LiveEventPost } from './LiveEventPost'
import { StyledLiveEventTimeline } from './LiveEventTimeline.styled'

export interface LiveEventTimelineProps {
    log: Logger
    posts: Array<PublishedLiveEventItem>
    pinnedPosts: PublishedLiveEventPost[]
    eventTitle: string
    onEvent: (event: LiveBlogEvents | SharingEvent | AdEvent) => void
    triggerLazyLoad: VoidFunction
    divRef?: React.RefObject<HTMLDivElement>
    adState: AdState
}

export const LiveEventTimeline: FC<LiveEventTimelineProps> = ({
    posts,
    pinnedPosts,
    eventTitle,
    log,
    triggerLazyLoad,
    onEvent,
    divRef,
    adState,
}) => {
    const { componentRef } = useIsComponentOnScreen('0px', triggerLazyLoad)

    const hasPinnedPosts = pinnedPosts.length > 0

    return (
        <StyledLiveEventTimeline ref={divRef}>
            {hasPinnedPosts && (
                <LiveEventPinnedPosts
                    pinned={pinnedPosts}
                    eventTitle={eventTitle}
                    log={log}
                    adUnitPath={adState.targeting.adUnitPath}
                    onEvent={onEvent}
                />
            )}
            {posts.map((post, index) => {
                switch (post.kind) {
                    case 'event-post':
                        return (
                            <LiveEventPost
                                key={post.id}
                                post={post}
                                log={log}
                                eventTitle={eventTitle}
                                adUnitPath={adState.targeting.adUnitPath}
                                lazyLoadRef={
                                    index === posts.length - 2
                                        ? componentRef
                                        : undefined
                                }
                                onEvent={onEvent}
                            />
                        )
                    case 'event-ad':
                        return (
                            <AdUnitWrapper
                                key={post.id}
                                noticePosition="above-center"
                                padding={[4, 0, 4, 0]}
                                adState={adState}
                                unitId={post.id}
                                onEvent={onEvent}
                                adType={'inline'}
                            />
                        )
                    default:
                        return null
                }
            })}
        </StyledLiveEventTimeline>
    )
}
